   (function(){
      emailjs.init("JLN545bRtFF4f-3_U");
   })();

  document.addEventListener('DOMContentLoaded', function() {

    const form = document.getElementById('afsContactForm');
    const submitBtn = document.getElementById('afs-submit-button');
    const originalBtnText = submitBtn.innerText;

    const modalOverlay = document.getElementById('afs-result-modal');
    const modalIcon = document.getElementById('afs-modal-icon');
    const modalTitle = document.getElementById('afs-modal-title');
    const modalBody = document.getElementById('afs-modal-body');
    const modalCloseX = document.getElementById('afs-modal-close-x');
    const modalCloseBtn = document.getElementById('afs-modal-close-btn');

    const snInput = document.getElementById('ContactFormSN');
    const snStar = document.getElementById('afs-sn-required-star');

    function showAfsModal(type, title, message) {
        modalOverlay.classList.add('open');
        modalIcon.className = 'afs-modal-icon'; 
        if (type === 'success') {
            modalIcon.classList.add('success');
            modalIcon.innerHTML = '&#10003;'; 
        } else {
            modalIcon.classList.add('error');
            modalIcon.innerHTML = '&#10005;'; 
        }
        modalTitle.textContent = title;
        modalBody.textContent = message;
    }

    function closeAfsModal() {
        modalOverlay.classList.remove('open');
    }

    modalCloseX.addEventListener('click', closeAfsModal);
    modalCloseBtn.addEventListener('click', closeAfsModal);
    modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
            closeAfsModal();
        }
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault(); 

      submitBtn.innerText = 'Sending...';
      submitBtn.disabled = true;

      emailjs.sendForm('service_r3lt825', 'template_wv6xq5r', this)
        .then(function() {
            console.log('SUCCESS!');
            
            showAfsModal('success', 'Thank You!', "Thanks for contacting us! We'll get back to you soon.");
            
            submitBtn.innerText = originalBtnText;
            submitBtn.disabled = false;
            form.reset(); 
            
            document.querySelectorAll('.afs-select-head').forEach(el => {
                el.innerText = el.id === 'afs-issue-head' ? 'Select an option' : 'Select a product model';
                el.classList.remove('has-value');
            });

            if(snInput) snInput.removeAttribute('required');
            if(snStar) snStar.style.display = 'none';
            
        }, function(error) {
            console.log('FAILED...', error);

            showAfsModal('error', 'Oops!', "Something went wrong. Please try again later.");

            submitBtn.innerText = originalBtnText;
            submitBtn.disabled = false;
        });
    });


    const textarea = document.getElementById('ContactFormMessage');
    if (textarea) {
      const autoResize = (el) => {
        el.style.height = 'auto'; 
        el.style.height = el.scrollHeight + 'px'; 
      };
      textarea.addEventListener('input', function() { autoResize(this); });
      setTimeout(() => autoResize(textarea), 100);
    }

    function toggleAfsSelect(head, body) {
        body.classList.toggle('open');
        head.classList.toggle('open');
        const parentGroup = head.closest('.afs-form-group');
        if (parentGroup) {
            parentGroup.classList.toggle('afs-z-index-active');
        }
    }

    function closeAfsSelect(head, body) {
        if (body) body.classList.remove('open');
        if (head) head.classList.remove('open');
        if (head) {
            const parentGroup = head.closest('.afs-form-group');
            if (parentGroup) {
                parentGroup.classList.remove('afs-z-index-active');
            }
        }
    }

    const issueSelectHead = document.getElementById('afs-issue-head');
    const issueSelectBody = document.getElementById('afs-issue-body');
    const issueHiddenInput = document.getElementById('ContactFormIssueHidden');
    const issueSelectOptions = issueSelectBody ? issueSelectBody.querySelectorAll('.afs-select-option') : [];
    const issueSelectContainer = document.getElementById('afs-issue-select');

    if (issueSelectHead && issueSelectBody) {
        issueSelectHead.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleAfsSelect(issueSelectHead, issueSelectBody);
        });

        issueSelectOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                e.stopPropagation();
                const value = this.getAttribute('data-value');
                const text = this.textContent;
                issueSelectHead.textContent = text;
                issueSelectHead.classList.add('has-value');
                issueHiddenInput.value = value;

                if (value === 'Technical support' || value === 'Buy after-sales materials') {
                    if(snInput) snInput.setAttribute('required', 'required');
                    if(snStar) snStar.style.display = 'inline';
                } else {
                    if(snInput) snInput.removeAttribute('required');
                    if(snStar) snStar.style.display = 'none';
                }
                // ------------------------------------

                closeAfsSelect(issueSelectHead, issueSelectBody);
            });
        });

        document.addEventListener('click', function(e) {
            if (issueSelectContainer && !issueSelectContainer.contains(e.target)) {
                closeAfsSelect(issueSelectHead, issueSelectBody);
            }
        });
    }

    const productModelSelectHead = document.getElementById('afs-product-model-head');
    const productModelSelectBody = document.getElementById('afs-product-model-body');
    const productModelHiddenInput = document.getElementById('ContactFormProductModelHidden');
    const productModelSelectOptions = productModelSelectBody ? productModelSelectBody.querySelectorAll('.afs-select-option') : [];
    const productModelSelectContainer = document.getElementById('afs-product-model-select');

    if (productModelSelectHead && productModelSelectBody) {
        productModelSelectHead.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleAfsSelect(productModelSelectHead, productModelSelectBody);
        });

        productModelSelectOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                e.stopPropagation();
                const value = this.getAttribute('data-value');
                const text = this.textContent;
                productModelSelectHead.textContent = text;
                productModelSelectHead.classList.add('has-value');
                productModelHiddenInput.value = value;
                closeAfsSelect(productModelSelectHead, productModelSelectBody);
            });
        });

        document.addEventListener('click', function(e) {
            if (productModelSelectContainer && !productModelSelectContainer.contains(e.target)) {
                closeAfsSelect(productModelSelectHead, productModelSelectBody);
            }
        });
    }
  });